/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 03/12/21
 */

import { createContext } from 'react';

export class InvalidContextError extends Error {
    constructor(contextName: string) {
        super(`${contextName} used outside of Provider`);
    }
}

export const THROW_INVALID_CONTEXT = (contextName: string) => () => {
    throw new InvalidContextError(contextName);
};

/**
 * Create a proxy which throws an error when accessing any property of a context
 * outside of a provider.
 * @param contextName Name of context to include in error message
 */
export const createUnprovisionedContext = <T>(contextName: string) => {
    return createContext(
        new Proxy(
            {},
            {
                get(): Record<string, unknown> {
                    throw new InvalidContextError(contextName);
                },
            },
        ) as T,
    );
};
